module.exports = __webpack_public_path__ + "img/logo_gifty_white.7d86ba28.svg";